import Page from 'src/components/molecules/page';
import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { FormSettingForm } from 'src/components/organisms/reservation-form-setting/form';

export const ReservationFormSettingCreatePage: FC = () => {
  /* 定数宣言 */
  const title = '予約フォーム登録';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <FormSettingForm />
      </Container>
    </Page>
  );
};
